import '@field-support/design-tokens/tokens.css';
import '@field-support/design-tokens/extensions.css';
// Tangram (D119): the product layer re-points the semantic tokens; load it last.
import '@field-support/design-tokens/tangram.css';
// Self-hosted faces (UX audit ND-1): IBM Plex Sans Arabic for interface text in both scripts
// (400–700), Alexandria for page, section and card titles and big numbers (600, 700), Geist Mono
// for codes only.
import '@fontsource/ibm-plex-sans-arabic/400.css';
import '@fontsource/ibm-plex-sans-arabic/500.css';
import '@fontsource/ibm-plex-sans-arabic/600.css';
import '@fontsource/ibm-plex-sans-arabic/700.css';
import '@fontsource/alexandria/600.css';
import '@fontsource/alexandria/700.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/500.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
